/**
 * ⓘ-Knopf (PV-037, A8): zeigt EIN Thema aus HILFE_THEMEN im Popover — dieselbe Komponente wie auf
 * der Hilfeseite — und verlinkt den Anker. Ist das Thema per Flag unsichtbar, gibt es auch keinen
 * Knopf (A2). Setzt „News gelesen bis" NICHT (anforderung.md).
 */
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useFeatureFlags } from '../../../lib/features.js';
import { Popover } from '../popover.js';
import { hilfeThema } from './hilfe-themen.js';
import type { HilfeThemaId } from './hilfe-typen.js';

export function InfoKnopf({ themaId }: { themaId: HilfeThemaId }) {
  const { t } = useTranslation();
  const { flags } = useFeatureFlags();
  const [offen, setOffen] = useState(false);
  const knopf = useRef<HTMLButtonElement>(null);
  const thema = hilfeThema(themaId);
  if (!thema.sichtbar(flags)) return null;

  const titel = t(thema.titelKey);
  const { Komponente } = thema;
  return (
    <>
      <button
        ref={knopf}
        type="button"
        aria-expanded={offen}
        aria-label={t('hilfe.seite.info_label', { thema: titel })}
        title={titel}
        onClick={() => setOffen((v) => !v)}
        className="inline-flex items-center justify-center rounded-full border text-[11px] font-semibold leading-none"
        style={{
          width: 18,
          height: 18,
          color: 'var(--ink-3)',
          borderColor: 'var(--line)',
          background: 'var(--surface)',
          fontFamily: 'var(--f-display)',
          cursor: 'pointer',
        }}
      >
        i
      </button>
      {offen && (
        <Popover
          anker={knopf}
          onClose={() => setOffen(false)}
          label={titel}
          breite={440}
          hoehe={480}
        >
          <div className="space-y-3 py-3">
            <h3 className="text-sm font-medium" style={{ color: 'var(--ink)' }}>
              {titel}
            </h3>
            <Komponente kompakt />
            <Link
              to={`/hilfe#${thema.anker}`}
              onClick={() => setOffen(false)}
              className="inline-block text-xs underline"
              style={{ color: 'var(--primary)' }}
            >
              {t('hilfe.seite.mehr')}
            </Link>
          </div>
        </Popover>
      )}
    </>
  );
}
